import ICONS from '@/shared/entities/constants/icons';

export enum BENEFICIARY_AVAILABLE_HOME_TABS_ID {
  BENEFICIARY,
  MOVES,
}

export enum BENEFICIARY_MAIN_FILTERS {
  NAME = 'name',
  CPF = 'cpf',
  STATUS = 'status',
}

export enum BENEFICIARY_EXTRA_FILTERS {
  OWNERSHIP = 'ownership',
  HEALTH_CARD = 'health_card',
  BENEFIT = 'benefit',
}

export enum BENEFICIARY_TABLE_COLUMN {
  NAME = 'name',
  CPF = 'cpf',
  HEALTH_CARD = 'healthCard',
  BENEFIT = 'benefit',
  STATUS = 'status',
}

export enum BENEFICIARY_TABLE_ACTION {
  DETAIL = 'detail',
}

export enum OWNERSHIP_TYPE {
  HOLDER = 'holder',
  DEPENDENT = 'dependent',
}

export enum BeneficiaryDetailTabLabels {
  INFO = 'Info',
  ADDRESS = 'Endereço',
  CONTACTS = 'Contatos',
  BENEFIT = 'Benefício',
  DEPENDENTS = 'Dependentes',
  HOLDER = 'Titular',
}

export const BENEFICIARY_AVAILABLE_DETAILS = [
  {
    index: 0,
    label: BeneficiaryDetailTabLabels.INFO,
    icon: 'info-outline',
    active: false,
  },
  {
    index: 1,
    label: BeneficiaryDetailTabLabels.ADDRESS,
    icon: 'pin-outline',
    active: false,
  },
  {
    index: 2,
    label: BeneficiaryDetailTabLabels.CONTACTS,
    icon: 'phone-call-outline',
    active: false,
  },
  {
    index: 3,
    label: BeneficiaryDetailTabLabels.BENEFIT,
    icon: 'activity-outline',
    active: false,
  },
  {
    index: 4,
    label: BeneficiaryDetailTabLabels.DEPENDENTS,
    icon: 'people-outline',
    active: false,
  },
  {
    index: 4,
    label: BeneficiaryDetailTabLabels.HOLDER,
    icon: 'person-outline',
    active: false,
  },
];

export const BENEFICIARY_AVAILABLE_HOME_TABS = [
  {
    id: BENEFICIARY_AVAILABLE_HOME_TABS_ID.BENEFICIARY,
    label: 'Beneficiários',
    icon: 'people-outline',
    active: false,
  },
  {
    id: BENEFICIARY_AVAILABLE_HOME_TABS_ID.MOVES,
    label: 'Histórico de movimentações',
    icon: ICONS.MOVE,
    active: false,
  },
];

export enum SELECT_BENEFICIARY_AVAILABLE_COLUMNS {
  NAME = 'name',
  CPF = 'cpf',
  PLAN = 'plan',
  BENEFIT = 'benefit',
}

export const MAX_BENEFICIARIES_EXPORTED_FILENAME_LENGTH = 255;
